import YFormContentTypeEditor from './ContentTypeEditor';

export { YFormContentTypeEditor };
export default YFormContentTypeEditor;
